module.exports = __webpack_public_path__ + "media/images/logos/linkedin-175px-026878b56ad0e9ae7cc27622a66dd6d8.jpg";